import { Quote } from "lucide-react";

const MEDIA = [
  { name: "USA News", serif: true, top: "USA", bottom: "NEWS" },
  { name: "International Business Times", serif: true, top: "INTERNATIONAL", bottom: "BUSINESS TIMES" },
  { name: "CEO Times", serif: true, top: "CEO", bottom: "TIMES" },
  { name: "Morning News", serif: true, top: "Morning", bottom: "NEWS" },
  { name: "Associated Press", serif: false, top: "AP", bottom: "Associated Press" },
  { name: "Barchart", serif: false, top: "Barchart", bottom: "MARKETS" },
  { name: "SBS Radio Bangla", serif: false, top: "SBS", bottom: "Radio Bangla" },
  { name: "Business America Magazine", serif: true, top: "Business America", bottom: "MAGAZINE" },
];

export default function FeaturedIn() {
  // duplicate for seamless marquee
  const items = [...MEDIA, ...MEDIA];

  return (
    <section data-testid="featured-in-section" className="py-20 md:py-24 bg-[#F8F9FA] border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <div className="text-[11px] font-bold tracking-[0.22em] text-[#C43A89] uppercase mb-4 flex items-center justify-center gap-3">
            <span className="brand-dot bg-[#C43A89]" />
            International Media Recognition
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#29324A] leading-tight">
            Featured In
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">
            Featured across leading international media platforms for contributions to <em>international education, entrepreneurship, leadership and innovation</em>.
          </p>
        </div>

        {/* Marquee */}
        <div className="relative overflow-hidden">
          <div className="pointer-events-none absolute inset-y-0 left-0 w-24 z-10 bg-gradient-to-r from-[#F8F9FA] to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-24 z-10 bg-gradient-to-l from-[#F8F9FA] to-transparent" />

          <div className="flex gap-px bg-slate-200 marquee-track">
            {items.map((m, i) => (
              <div
                key={i}
                data-testid={`media-logo-${i % MEDIA.length}`}
                className="bg-white px-8 py-7 min-w-[220px] flex flex-col items-center justify-center text-center group hover:bg-[#F3F2F0] transition-colors"
                aria-label={m.name}
              >
                <div className={`${m.serif ? "font-display" : "font-sans"} text-[#29324A] leading-tight tracking-tight`}>
                  <div className={`${m.serif ? "text-xl" : "text-2xl font-extrabold"} group-hover:text-[#29324A] transition-colors`}>
                    {m.top}
                  </div>
                  <div className={`${m.serif ? "text-[10px] font-bold tracking-[0.22em] mt-1" : "text-[10px] font-bold tracking-[0.18em] mt-1"} text-slate-500 uppercase`}>
                    {m.bottom}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 flex items-center justify-center gap-3 text-xs text-slate-500">
          <Quote className="h-4 w-4 text-[#C43A89]" />
          <span className="italic">Personal media recognition for Shamima Yasmin Anwar.</span>
        </div>
      </div>

      <style>{`
        @keyframes marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        .marquee-track { animation: marquee 40s linear infinite; width: max-content; }
        .marquee-track:hover { animation-play-state: paused; }
      `}</style>
    </section>
  );
}
